import { timelineOptions } from "@/pages/planogram/timeline-options";
import { useEffect, useRef, useState } from "react";
import { DataSet } from "vis-data";
import { Timeline as VisTimeline } from "vis-timeline/esnext";

export const useTimeline = ({
  onTimeChange,
  onTimeChanged,
  onDoubleClick,
  onRangeChange,
  onRangeChanged,
}: {
  onTimeChange: (event: any) => void;
  onTimeChanged: (event: any) => void;
  onDoubleClick: (event: any) => void;
  onRangeChange: (event: any) => void;
  onRangeChanged: (event: any) => void;
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [dataset] = useState<DataSet<any, any>>(() => new DataSet());
  const [groups] = useState<DataSet<any, any>>(() => new DataSet());
  const timelineRef = useRef<VisTimeline | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const timeline = new VisTimeline(
      containerRef.current,
      dataset,
      timelineOptions
    );

    timelineRef.current = timeline;

    timeline.on("timechange", onTimeChange);
    timeline.on("timechanged", onTimeChanged);
    timeline.on("rangechange", onRangeChange);
    timeline.on("rangechanged", onRangeChanged);
    timeline.on("doubleClick", onDoubleClick);

    return () => {
      timeline.off("timechange", onTimeChange);
      timeline.off("timechanged", onTimeChanged);
      timeline.off("doubleClick", onDoubleClick);
      timeline.off("rangechange", onRangeChange);
      timeline.off("rangechanged", onRangeChanged);
      timeline.destroy();
    };
  }, []);

  return {
    timelineRef,
    containerRef,
    dataset,
    groups,
  };
};
